import Extra from './Extra'
import Requirement from './Requirement';

export class MovitInstanceConfig {

    static featurePassengerPropertyChanges: string = "FeaturePassengerPropertyChanges";
    instanceId: number = 0;
    currencySymbol: string = '';
    isMileageInstance: boolean = false;
    extras: Extra[] = [];
    supportedFeatures: string[] = [];
    requirements: Requirement[] = [];

    get supportsFeaturePassengerPropertyChanges(): boolean {
        return this.supportedFeatures.includes(MovitInstanceConfig.featurePassengerPropertyChanges);
    }

    public static fromApi(apiMovitInstanceConfig: any): MovitInstanceConfig {
        const movitInstanceConfig = new MovitInstanceConfig();
        movitInstanceConfig.instanceId = apiMovitInstanceConfig.instanceId;
        movitInstanceConfig.currencySymbol = apiMovitInstanceConfig.currencySymbol;
        movitInstanceConfig.isMileageInstance = apiMovitInstanceConfig.isMileageInstance;
        movitInstanceConfig.extras = apiMovitInstanceConfig.extras 
            ? apiMovitInstanceConfig.extras.map((e: any) => Extra.fromApi(e))
            : [];

        movitInstanceConfig.supportedFeatures = apiMovitInstanceConfig.supportedFeatures 
            ? apiMovitInstanceConfig.supportedFeatures 
            : [];

        movitInstanceConfig.requirements = apiMovitInstanceConfig.requirements
            ? apiMovitInstanceConfig.requirements.map((r: any) => Requirement.fromApi(r))
            : [];

        return movitInstanceConfig;
    }

}

export default MovitInstanceConfig;
